var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.44 51.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0064b1;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #49c8f5;\n      }\n\n      .cls-3 {\n        fill: #0096db;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.84,29.09l.78.52c2.42,1.61,2.42,4.24,0,5.85l-22.01,14.63c-2.42,1.61-6.37,1.61-8.79,0L1.81,35.45c-2.42-1.61-2.42-4.24,0-5.85l.78-.52,23.67,15.74c1.07.71,2.83.71,3.91,0l23.67-15.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.84,22.2l.78.52c2.42,1.61,2.42,4.24,0,5.85l-24.45,16.26c-1.07.71-2.83.71-3.91,0L1.81,28.57c-2.42-1.61-2.42-4.24,0-5.85l.78-.52,23.67,15.74c1.07.71,2.83.71,3.91,0l23.67-15.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.62,1.21l19.09,12.69c.53.35.53.93,0,1.29l-23.49,15.62-11.15-7.41-6.35,4.22L1.81,21.68c-2.42-1.61-2.42-4.24,0-5.85L23.82,1.21c2.42-1.61,6.37-1.61,8.79,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/Accounting.5abdde4c1e9b293768b9e6d7a8613589.svg";
export { ForwardRef as ReactComponent };